import i18n from '@src/i18n/config';

const getLanguagePart = (language) => language?.split('-')[0];

/**
 * Pick the first browser-preferred language supported by the translation service.
 * Fall back to the active i18next language, then English, when the browser preference is missing
 * or unsupported.
 * @param {Array<{label: string, value: string}>} languageOptions
 * @param {string[]} [browserLanguages]
 * @param {string} [activeLanguage]
 * @returns {string|null}
 */
export const getDefaultSourceLanguage = (
  languageOptions,
  browserLanguages = typeof navigator !== 'undefined'
    ? navigator.languages || [navigator.language]
    : [],
  activeLanguage = i18n.language || i18n.resolvedLanguage
) => {
  const supportedLanguages = new Map(
    languageOptions.map(({ value }) => [value.toLowerCase(), value])
  );
  const configuredLanguage = i18n.options?.lng || 'en';
  const preferredLanguages =
    activeLanguage && activeLanguage !== configuredLanguage
      ? [activeLanguage, ...browserLanguages, configuredLanguage]
      : [...browserLanguages, activeLanguage, configuredLanguage];

  for (const preferredLanguage of preferredLanguages) {
    const language = getLanguagePart(preferredLanguage);
    if (language && supportedLanguages.has(language)) return supportedLanguages.get(language);
  }

  return null;
};
